import React from 'react';
import Modal from 'react-modal';
import { IoMdCloseCircleOutline } from "react-icons/io";
import ScrollAnimation from 'react-animate-on-scroll';
import Slider from "react-slick";
import 'animate.css';

function CustomGallery({ myGallery }) {

    const [modalIsOpen, setIsOpen] = React.useState(false);
    const sliderRef = React.useRef(null);

    function openModal(index) {
        setIsOpen(true);

        setTimeout(() => {
            sliderRef.current?.slickGoTo(index);
        }, 0);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        myGallery ? (
            <section className="mb-[60px] lg:mb-[120px]">
                <div className="container mx-auto text-center">
                    <ScrollAnimation animateIn="animate__fadeInUp">
                        <h2 className="sm:text-4xl text-2xl uppercase">
                            {myGallery.gallery_title}
                        </h2>
                    </ScrollAnimation>
                </div>

                <div className="grid md:grid-cols-3 gap-2 py-6">
                    {myGallery.gallery_item.map((item, index) => (
                        <a href="#" key={index} className="overflow-hidden"
                            onClick={(e) => {
                                e.preventDefault();
                                openModal(index);
                            }}
                        >
                            <img src={item} alt="img" className="hover:scale-110 transition duration-300" />
                        </a>
                    ))}
                </div>

                <Modal isOpen={modalIsOpen} onRequestClose={closeModal} ariaHideApp={false}>
                    <button onClick={closeModal} className="absolute top-0 left-0 right-0 z-[999]">
                        <IoMdCloseCircleOutline className="text-red-800 text-4xl" />
                    </button>

                    <Slider ref={sliderRef} {...settings}>
                        {myGallery.gallery_item.map((item, index) => (
                            <div key={index}>
                                <img src={item} alt="img" className="w-full h-auto"
                                />
                            </div>
                        ))}
                    </Slider>
                </Modal>
            </section>
        ) : null
    );
}

export default CustomGallery;